(function () {
  var initializedItems = new WeakSet();
  var initializedSwatches = new WeakSet();

  function initItem(item) {
    if (initializedItems.has(item)) return;
    initializedItems.add(item);

    var cardId = item.dataset.cardId;
    var cardEl = cardId ? document.getElementById(cardId) : item.closest('product-card');
    if (!cardEl) return;

    var galleryImg = cardEl.querySelector('[ref="cardGallery"] img, .card-gallery img');
    if (!galleryImg) return;

    var originalSrc = galleryImg.src;
    var originalSrcset = galleryImg.srcset;

    item.addEventListener('mouseenter', function () {
      var img01 = item.dataset.image01;
      if (img01) { galleryImg.src = img01; galleryImg.srcset = ''; }
    });
    item.addEventListener('mouseleave', function () {
      galleryImg.src = originalSrc;
      galleryImg.srcset = originalSrcset;
    });
  }

  function initCarousel(swatchEl) {
    if (initializedSwatches.has(swatchEl)) return;
    initializedSwatches.add(swatchEl);

    var list = swatchEl.querySelector('.em-swatches__list--scrollable');
    if (!list) return;

    function updateState() {
      var canPrev = list.scrollLeft > 2;
      var canNext = list.scrollLeft + list.clientWidth < list.scrollWidth - 2;
      swatchEl.classList.toggle('em-swatches--can-prev', canPrev);
      swatchEl.classList.toggle('em-swatches--can-next', canNext);
    }
    updateState();
    // 画像読み込み後にレイアウトが確定するため、段階的に再計算
    setTimeout(updateState, 50);
    setTimeout(updateState, 300);
    setTimeout(updateState, 1000);
    // ResizeObserver で画像描画後に再計算
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateState).observe(list);
    }
    // 各画像のload後に再計算（lazy loadで遅れて読み込まれる場合の対策）
    list.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', updateState, { once: true });
      }
    });
    // IntersectionObserver でスクロールにより表示されたタイミングで再計算
    if (typeof IntersectionObserver !== 'undefined') {
      new IntersectionObserver(function (entries, obs) {
        if (entries[0].isIntersecting) {
          updateState();
          setTimeout(updateState, 100);
          obs.disconnect();
        }
      }, { threshold: 0.1 }).observe(swatchEl);
    }
    list.addEventListener('scroll', updateState);
    window.addEventListener('resize', updateState);

    var scrollAmount = 44;
    var prevBtn = swatchEl.querySelector('.em-swatches__nav--prev');
    var nextBtn = swatchEl.querySelector('.em-swatches__nav--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        list.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        list.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('.em-swatches--card .em-swatches__item[data-image-01]').forEach(initItem);
    (root || document).querySelectorAll('.em-swatches--card').forEach(initCarousel);
  }

  function start() {
    initAll();
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('.em-swatches--card')) {
            initCarousel(node);
            node.querySelectorAll('.em-swatches__item[data-image-01]').forEach(initItem);
          } else {
            node.querySelectorAll('.em-swatches--card').forEach(initCarousel);
            node.querySelectorAll('.em-swatches--card .em-swatches__item[data-image-01]').forEach(initItem);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
